export const tableOptions = {
  data() {
    return {
      loadingInstance: false,
      checkboxOption: {
        selectedRowKeys: [],
        // row select change event
        // eslint-disable-next-line no-unused-vars
        selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
          this.changeSelectedRowKeys(selectedRowKeys)
        },
        // selected all change event
        // eslint-disable-next-line no-unused-vars
        selectedAllChange: ({ isSelected, selectedRowKeys }) => {
          this.changeSelectedRowKeys(selectedRowKeys)
        },
      },
      cellSelectionOption: {
        enable: false
      },
      rowStyleOption: {
        stripe: true
      }
    }
  },
  mounted() {
    this.loadingInstance = this.$veLoading({
      target: document.getElementById('table-main-card-body'),
      name: 'wave'
    })
  },
  methods: {
    changeSelectedRowKeysByRowClick(currentRowKey) {
      const { selectedRowKeys } = this.checkboxOption

      if (selectedRowKeys.includes(currentRowKey)) {
        const rowKeyIndex = selectedRowKeys.indexOf(currentRowKey)
        selectedRowKeys.splice(rowKeyIndex, 1)
      } else {
        selectedRowKeys.push(currentRowKey)
      }
      this.dataTableSelected = selectedRowKeys
    },
    changeSelectedRowKeys(keys) {
      this.checkboxOption.selectedRowKeys = keys
      this.dataTableSelected = keys
    },
    unselectedAll() {
      this.checkboxOption.selectedRowKeys = []
      this.dataTableSelected = []
    }
  }
}
